import { createContext, useContext } from 'react';
import type { BankAccountFormVerification } from './BankAccountFormContext.types.ts';

export const BankAccountVerificationContext = createContext<BankAccountFormVerification | null>(
	null
);

export const useBankAccountVerificationContext = (): BankAccountFormVerification => {
	const context = useContext(BankAccountVerificationContext);

	if (!context) {
		throw new Error(
			'useBankAccountVerificationContext must be used within a BankAccountVerificationScope'
		);
	}
	return context;
};
